import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private apiService: ApiService) { }

  openRazorPayForAddingCard(requestObj) {
    return this.apiService.httpRequest({
      url: 'openRazorPayForAddingCard',
      type: 'POST',
      body: requestObj
    });
  }

  initiatePayment(requestObj) {
    return this.apiService.httpRequest({
      url: 'initiatePayment',
      type: 'POST',
      body: requestObj
    });
  }

  fetchCardDetails(request: any) {
    return this.apiService.checkResponseStatus({
      url: 'fetchCardDetails',
      type: 'POST',
      body: request
    });
  }

  removeCard(request: any) {
    return this.apiService.httpRequest({
      url: 'removeCard',
      type: 'POST',
      body: request,
    });
  }

  makeDefaultCard(request: any) {
    return this.apiService.httpRequest({
      url: 'defaultCard',
      type: 'POST',
      body: request,
    });
  }
}
